<div #corner class="fabs">
  <div class="fabs__stack">
    <!-- back to the top: a recliner dozing in a ring that fills as the page goes down -->
    <button #top type="button" class="top" aria-label="Back to top" (click)="toTop()">
      <svg class="top__ring" viewBox="0 0 54 54" aria-hidden="true">
        <circle cx="27" cy="27" r="25.5" />
        <circle class="top__depth" cx="27" cy="27" r="25.5" pathLength="100" />
      </svg>
      <!-- (seen from the side: back, footrest, seat, arm and its post, pedestal, base — and its dozing z's) -->
      <svg class="chair" viewBox="0 0 48 40" aria-hidden="true">
        <rect class="chair__back" x="16" y="6" width="6.6" height="21" rx="3.3" />
        <rect class="chair__foot" x="32" y="23" width="5" height="11" rx="2.5" />
        <rect x="17" y="21.5" width="18" height="6.8" rx="3.2" />
        <rect x="18.5" y="16.4" width="12.5" height="3.6" rx="1.8" />
        <rect x="26.6" y="18" width="2.8" height="5" rx="1.4" />
        <rect x="24" y="28" width="3.4" height="4.6" />
        <rect x="18" y="32" width="15.4" height="2.8" rx="1.4" />
        <text class="chair__z" x="13" y="8">z</text>
        <text class="chair__z chair__z--late" x="19" y="4">z</text>
      </svg>
      <span class="top__label" aria-hidden="true">Back to top</span>
    </button>

    <button type="button" class="fab fab--finder" (click)="popups.show('finder')">Find My Recliner</button>
    @if (!popups.claimed()) {
      <button type="button" class="fab fab--enquiry" (click)="popups.show('enquiry')">Enquire Now</button>
    }
  </div>
</div>
